import React from 'react';

function CalendarIcon({ width = 18, height = 23, ...rest }) {
  // tslint:disable max-line-length
  return (
    <svg {...rest} width={width} height={height} viewBox="0 0 18 23">
      <g>
        <path d="M17,19.8657336 L17,4.63426638 C17,3.87033675 16.4003614,3.25 15.678604,3.25 L2.32139605,3.25 C1.59963862,3.25 1,3.87033675 1,4.63426638 L1,19.8657336 C1,20.6296633 1.59963862,21.25 2.32139605,21.25 L15.678604,21.25 C16.4003614,21.25 17,20.6296633 17,19.8657336 Z M18,19.8657336 C18,21.174497 16.9603822,22.25 15.678604,22.25 L2.32139605,22.25 C1.03961782,22.25 8.34368004e-16,21.174497 8.34368004e-16,19.8657336 L8.34368004e-16,4.63426638 C8.34368004e-16,3.32550299 1.03961782,2.25 2.32139605,2.25 L15.678604,2.25 C16.9603822,2.25 18,3.32550299 18,4.63426638 L18,19.8657336 Z" />
        <path d="M4,0.5 C4,0.223857625 4.22385763,-9.71445147e-16 4.5,-9.71445147e-16 C4.77614237,-9.71445147e-16 5,0.223857625 5,0.5 L5,5.5 C5,5.77614237 4.77614237,6 4.5,6 C4.22385763,6 4,5.77614237 4,5.5 L4,0.5 Z" />
        <path d="M13,0.5 C13,0.223857625 13.2238576,-3.1918912e-15 13.5,-3.1918912e-15 C13.7761424,-3.1918912e-15 14,0.223857625 14,0.5 L14,5.5 C14,5.77614237 13.7761424,6 13.5,6 C13.2238576,6 13,5.77614237 13,5.5 L13,0.5 Z" />
        <polygon points="0.5 9.25 0.5 8.25 17.5 8.25 17.5 9.25" />
      </g>
    </svg>
  );
  // tslint:enable max-line-length
}

export default CalendarIcon;
